export default __webpack_public_path__ + "static/bar-with-labels-c1997e87c4f2f60c069dad8ab2516b7d.png";